import { BasePlugin } from '../base'
import mdcCheckbox from './mdc-checkbox.vue'

export { mdcCheckbox }

export default BasePlugin({
  mdcCheckbox
})
